export const AGENTIC_CHAT_BUDDY_URL = 'https://agentic.dev.share2act.cn';
